<template>
  <div class="onboarding-day">
    <label class="form-check form-switch form-check-custom form-check-solid onboarding-day__toggle">
      <input class="form-check-input" type="checkbox" :checked="day.enabled" @change="toggleDay">
      <span class="form-check-label fw-bold">{{ day.name }}</span>
    </label>

    <div class="onboarding-day__ranges" :class="{ 'opacity-50': !day.enabled }">
      <div class="onboarding-range" v-for="(range, index) in day.ranges" :key="index">
        <span class="text-muted fs-7">{{ index === 0 ? 'Manhã' : 'Tarde' }}</span>
        <input
          type="text"
          v-mask="'##:##'"
          class="form-control form-control-solid"
          :value="range.time_begin"
          :disabled="!day.enabled"
          @input="updateRange(index, 'time_begin', $event.target.value)"
        >
        <span class="text-muted">até</span>
        <input
          type="text"
          v-mask="'##:##'"
          class="form-control form-control-solid"
          :value="range.time_end"
          :disabled="!day.enabled"
          @input="updateRange(index, 'time_end', $event.target.value)"
        >
      </div>
    </div>
  </div>
</template>

<script>
import { mask } from 'vue-the-mask';

export default {
  name: 'OnboardingWeekdayRow',
  directives: { mask },
  props: {
    day: {
      type: Object,
      required: true,
    },
  },
  emits: ['change'],
  methods: {
    toggleDay(event) {
      this.$emit('change', { ...this.day, enabled: event.target.checked });
    },
    updateRange(index, field, value) {
      const ranges = this.day.ranges.map((range, rangeIndex) => {
        return rangeIndex === index ? { ...range, [field]: value } : range;
      });

      this.$emit('change', { ...this.day, ranges });
    },
  },
};
</script>

<style scoped>
.onboarding-day {
  display: grid;
  grid-template-columns: 150px 1fr;
  gap: 1rem;
  padding: 1rem;
  border: 1px solid #edf0f5;
  border-radius: 14px;
  background: #fff;
}

.onboarding-day__toggle {
  align-items: center;
  margin: 0;
}

.onboarding-day__ranges {
  display: grid;
  gap: 0.75rem;
}

.onboarding-range {
  display: grid;
  grid-template-columns: 56px minmax(88px, 1fr) 28px minmax(88px, 1fr);
  gap: 0.6rem;
  align-items: center;
}

@media (max-width: 767px) {
  .onboarding-day {
    grid-template-columns: 1fr;
  }

  .onboarding-range {
    grid-template-columns: 48px 1fr 24px 1fr;
  }
}
</style>
